module.exports = __webpack_public_path__ + "img/Webで学ぶ JavaScript 2020_3_1.ee6537b7.jpeg";